import script from "./ConmedInformation.vue?vue&type=script&setup=true&lang=js"
export * from "./ConmedInformation.vue?vue&type=script&setup=true&lang=js"

import "./ConmedInformation.vue?vue&type=style&index=0&id=7538685e&scoped=true&lang=css"

import exportComponent from "E:\\gcm3\\AI Inventory\\codebase\\demo-legacy-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7538685e"]])

export default __exports__